<template>
  <div>
    <div class="search_btn_wrap flex v_center">
      <h1 class="mb-0 mr-4">Advertiser Profiles</h1>
      <v-btn color="primary" @click="openModalNewAdvertiser = !openModalNewAdvertiser"><v-icon class="mr-2">mdi-plus</v-icon> New Advertiser</v-btn>
      <v-btn @click="exportAdvertiserList" color="primary" class="btn-inner ml-5">
        <v-icon class="mr-2">mdi-download</v-icon>
        Export
      </v-btn>
    </div>

    <v-data-table
        :headers="table.headers"
        :header-props="{ sortIcon: null, headerClass: 'white-space-no-wrap' }"
        :items="profiles.data"
        :server-items-length="profiles.count"
        :disable-sort="true"
        :loading="table.loading"
        :footer-props="{itemsPerPageOptions: table.pageOptions}"
        :page="table.currentPage"
        :items-per-page="table.itemsPerPage"
        loading-text="Loading... Please wait"
        fixed-header
        :class="`elevation-1 fixed-height co-data-table items-size-${table.heightCounter}`"
        item-class="td_title"
        color="#7F98A5"
        @pagination="updateTablePagination"
    >
      <template v-slot:top>
        <DataTableTopBar @search="search"></DataTableTopBar>
      </template>
      <template v-for="item of table.headers" :slot="`header.${[item.value]}`" slot-scope="{header}">
        <data-filter type="items"
                     v-if="table.filters.hasOwnProperty(header.value)"
                     :items="table.filters[header.value].data"
                     :entity="header.value"
                     :values="table.filters[header.value].selected"
                     @apply="submitFilter"
                     @search="updateDataInFilters"
        ></data-filter>
        <a v-if="header.sortable === undefined || header.sortable" @click="sortColumn(header.value)">
          <span class="header_title">{{header.text}}</span>
          <v-icon size="16" color="#7F98A5">mdi-arrow-{{header.value === table.orderBy ? table.sortColumnsAsc ? 'up' : 'down' : 'up-down'}}</v-icon>
        </a>
        <span v-else class="header_title">{{header.text}}</span>
      </template>
      <!-- header -->
      <!-- body -->
      <template v-for="header of table.headers" :slot="`item.${[header.value]}`" slot-scope="{item}">
        <template v-if="header.value === 'actions'">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <a class="no-underline" :href="getReportsUrl(item)" v-bind="attrs" v-on="on" target="_blank">
                <v-icon color="accent">fal fa-analytics</v-icon>
              </a>
            </template>
            <span>Reports</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" icon color="secondary" @click="activateEmailManually(item)">
                <v-icon v-if="item.verified">mdi-email</v-icon>
                <v-icon v-else>mdi-email-outline</v-icon>
              </v-btn>
            </template>
            <span v-if="item.verified">Verified Email</span>
            <span v-else>Activate Email Manually</span>
          </v-tooltip>
          <v-tooltip top >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                  :disabled="!user[0].can('edit_advertiser')"
                  v-bind="attrs"
                  v-on="on"
                  icon
                  color="primary"
                  @click="editAdvertiser(item)"
              >

                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </template>
            <span>Edit Advertiser</span>
          </v-tooltip>
        </template>
        <template v-if="header.value === 'currency'">
          <v-tooltip top open-delay="400">
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on">{{item.currency}}</span>
            </template>
            <span>{{item.currencyName}}</span>
          </v-tooltip>
        </template>
        <template v-else-if="isEntityName(header.value)">
          <a class="entity-link" @click="showCard(item)">{{item[header.value]}}</a>
        </template>
        <template v-else-if="header.value === 'verticalNames'">
          <div class="verticals-container">
            <v-chip
                    v-if="item.verticalNames"
                    v-for="(vertical, index) in item.verticalNames.split('^')"
                    :key="index"
                    color="primary"
                    class="tag"
                    text-color="white">
              {{ vertical }}
            </v-chip>
          </div>
        </template>
        <template v-else>{{item[header.value]}}</template>
      </template>
    </v-data-table>
    <v-dialog
        v-model="openModalNewAdvertiser"
        max-width="500px"
    >
      <v-card>
        <v-card-title>
          <span class="headline">Create Advertiser</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row align="center">
              <v-col
                  cols="12"
                  sm="12"
              >
                <v-text-field
                    v-model="newAdvertiserData.name"
                    label="Name"
                ></v-text-field>
                <span class="custom-error" v-if="showErrors && !newAdvertiserData.name">required</span>
              </v-col>
              <v-col
                      cols="12"
                      sm="12"
              >
                <v-text-field
                        v-model="emailInput"
                        @keyup.enter="addEmail"
                        @keydown.tab="addEmail"
                        @keyup="checkForSpecialSymbol"
                        @blur="addEmail"
                        label="Email"
                ></v-text-field>
                <div class="chips-container">
                  <div
                          v-for="(email, index) in emails"
                          :key="index"
                          class="chip"
                  >
                    <span v-if="index === 0">{{ email }} (default)</span>
                    <span v-else>{{ email }}</span>
                    <span class="delete" @click="removeEmail(index)">x</span>
                  </div>
                </div>
                <span class="custom-error" v-if="showErrors && !emails.length">required</span>
                <span class="custom-error" v-if="emailError">invalid email</span>
              </v-col>
              <v-col
                      cols="6"
                      sm="6"
                      lg="6"
              >
                <v-text-field
                        v-model="newAdvertiserData.IMService"
                        label="IM Service"
                ></v-text-field>
              </v-col>
              <v-col
                      cols="6"
                      sm="6"
                      lg="6"
              >
                <v-text-field
                        v-model="newAdvertiserData.IMContact"
                        label="IM Contact"
                ></v-text-field>
              </v-col>
              <v-col
                      cols="12"
                      sm="12"
              >
                <v-text-field v-if="user[0].can('edit_payin_payout')"
                        v-model="newAdvertiserData.margin"
                        label="Margin"
                        :rules="[rules.required, rules.float, rules.positive]"
                        suffix="%"
                ></v-text-field>
              </v-col>
              <v-col
                  cols="12"
                  sm="12"
              >
                <v-select
                    v-model="newAdvertiserData.advertiserManagerId"
                    :items="$store.state.managers.affiliateManagers"
                    item-value="id"
                    item-text="name"
                    label="Advertiser Manager"
                ></v-select>
                <span class="custom-error" v-if="showErrors && !newAdvertiserData.advertiserManagerId">required</span>
              </v-col>
              <v-col
                      cols="12"
                      sm="12"
              >
                <v-autocomplete
                        label = "Vertical"
                        v-model="selectedVerticals"
                        :items="filteredVerticals"
                        item-text="name"
                        multiple
                        chips
                        small-chips
                        :menu-props="{ maxHeight: '400' }"
                        class="custom_autocomplete"
                        :search-input.sync="searchTerm"
                        @keyup.enter="addNewVertical"
                >
                  <template v-slot:selection="{ item, index }">
                    <v-chip
                            small
                            label
                            close
                            @click:close="removeVertical(index)"
                    >
                      {{ item.name }}
                    </v-chip>
                  </template>
                  <template v-slot:no-data>
                    <span>Press enter to create new item</span>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col
                  cols="12"
                  sm="12"
              >
                <v-select
                        v-model="newAdvertiserData.methodId"
                        :items="methods"
                        item-value="id"
                        item-text="name"
                        label="Payment Methods"
                        @change="clearPaymentDetails"
                ></v-select>
                <div v-if="currentPaymentMethod && currentPaymentMethod.tipalti">
                  <p class="tipalti">
                    This payment method is managed by Tipalti
                    <img class="tipalti-logo" src="@/assets/tipalti.png" alt="Tipalti Icon">
                    <br>
                  </p>
                </div>
                <div v-if="currentPaymentMethod && !currentPaymentMethod.tipalti">
                  <template v-for="pdField in paymentDetails[currentPaymentMethod.id]">
                    <div class="my-field-group" :key="`field_${pdField.field}`">
                      <template>
                        <v-text-field
                            :id="`field_${pdField.field}`"
                            :name="pdField.field"
                            :rules="pdField.rules"
                            v-model="newAdvertiserData.paymentDetails[pdField.field]"
                            :label="pdField.label"
                        ></v-text-field>
                      </template>
                    </div>
                  </template>
                </div>
              </v-col>

              <v-col cols="12" sm="12">
                <v-select
                  label="Billing Cycle"
                  hide-details
                  :items="['weekly', 'semimonthly', 'monthly']"
                  v-model="newAdvertiserData.billingCycle"
                ></v-select>
                <span class="custom-error" v-if="showErrors && !newAdvertiserData.billingCycle">required</span>
              </v-col>

              <v-col cols="12" lg="2">Status</v-col>
              <v-col
                  cols="12"
                  lg="12"
              >
                <v-switch
                    v-model="newAdvertiserData.status"
                    true-value="active"
                    false-value="inactive"
                    :label="newAdvertiserData.status"
                    class="edit-modal-switch"
                >
                </v-switch>
              </v-col>
              <v-col
                  cols="6"
                  lg="6"
              >
                <v-text-field
                    v-model="newAdvertiserData.productDescription"
                    label="Product description"
                ></v-text-field>
                <span class="custom-error" v-if="showErrors && !newAdvertiserData.productDescription">fill product description or website</span>
              </v-col>
              <v-col
                  cols="6"
                  sm="6"
              >
                <v-text-field
                    v-model="newAdvertiserData.website"
                    label="Website"
                ></v-text-field>
                <span class="custom-error" v-if="showErrors && !newAdvertiserData.website">fill product description or website</span>
              </v-col>
              <v-col
                  cols="12"
                  sm="12"
              >
                <v-text-field
                    v-model="newAdvertiserData.businessName"
                    label="Business Name or DBA"
                ></v-text-field>
                <span class="custom-error" v-if="showErrors && !newAdvertiserData.businessName">required</span>
              </v-col>

              <v-col
                  cols="12"
                  lg="12"
              >
                <v-textarea
                    v-model="newAdvertiserData.description"
                    solo
                    name="input-7-4"
                    label="Description"
                ></v-textarea>
                <span class="custom-error" v-if="showErrors && !newAdvertiserData.description">required</span>
              </v-col>
              <v-col
                      cols="12"
                      sm="12"
              >
                <v-file-input
                        v-model="newAdvertiserData.files"
                        multiple
                        label="Upload Files"
                        prepend-icon="mdi-paperclip"
                        accept=".jpg,.jpeg,.png,.pdf,.doc,.docx"
                        show-size
                        outlined
                ></v-file-input>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="secondary"
              text
              @click="closeModalNewAdvertiser"
          >
            Cancel
          </v-btn>
          <v-btn
              color="primary"
              text
              @click="createAdvertiser"
          >
            Save
          </v-btn>
        </v-card-actions>
        <div class="loader-wrapper" v-if="loading">
          <v-progress-circular
              :size="50"
              color="primary"
              indeterminate
          ></v-progress-circular>
        </div>
      </v-card>
    </v-dialog>
    <div class="loader-wrapper" v-if="loading">
      <v-progress-circular
          :size="50"
          color="primary"
          indeterminate
      ></v-progress-circular>
    </div>
    <DataTableBottomBar
        :showFilter="Object.values(table.filters).find(f => f.selected.length) !== undefined"
        @clearFilters="removeAllFilters"
        v-model="table.heightCounter"
    ></DataTableBottomBar>
    <ExportSettingsModal
      :isShow="isShowOpenSettingsModal"
      :headers="table.headers.map(h=>h.value)"
      :example="profiles && profiles.data && profiles.data.length ?  profiles.data[0] : null "
    >
    </ExportSettingsModal>
  </div>
</template>

<script>
  import MainLayout from "../../layouts/MainLayout"
  import store from "@/store";
  import { mapActions, mapGetters, mapState } from 'vuex'
  import DataTableTopBar from "@/components/common/DataTableTopBar";
  import DataTableBottomBar from "@/components/common/DataTableBottomBar";
  import advertisers from "@/api/advertisers";
  import verticalsApi from "@/api/verticals";
  import ExportSettingsModal from "@/components/pages/advertisers/ExportSettingsModal";
  import paymentDetails from "@/helpers/paymentDetails";
  import { convertFileToBase64 } from "@/helpers";

  export default {
    data() {
      return {
        verticals: [],
        selectedVerticals: [],
        selectedVerticalIds: [],
        methods: [],
        searchTerm: "",
        isShowOpenSettingsModal: false,
        paymentDetails,
        emailInput: '',
        emailError: false,
        emails: [],
        openModalNewAdvertiser: false,
        newAdvertiserData: {
          status: 'active',
          paymentDetails: {}
        },
        showErrors: false,
        loading: false,
        searchInProfiles: '',
        rules: {
          required: value => !!value || this.marginRequiredError,
          float: value => {
            const pattern = /^[+-]?([0-9]+([.][0-9]*)?|[.][0-9]+)$/
            return pattern.test(value) || 'Invalid value'
          },
          positive: value => Number(value) >= 0 || 'Must be positive or 0'
        },
        marginRequiredError: 'Please set the Advertiser margin before saving.',
        table: {
          heightCounter: 48,
          loading: false,
          awaitingSearch: false,
          currentPage: 1,
          itemsPerPage: 25,
          pageChangedByMe: false,
          pageOptions: [10, 25, 50, 100],
          orderBy: 'status',
          sortColumnsAsc: true,
          filtersPropertiesMap: {
            nameId: 'nameId',
            tags: 'tags',
            status: 'status',
            advertiserManager: 'advertiserManager',
          },
          headers: [
            { text: 'Id', value: 'id', class: 'color', width: 100, filterable: true },
            { text: 'Name', value: 'name', class: 'color', filterable: true },
            { text: 'Email', value: 'email', class: 'color', filterable: true },
            { text: 'Tags', value: 'tags', class: 'color', sortable: false, filterable: true },
            { text: 'Status', value: 'status', class: 'color', filterable: true },
            { text: 'Verticals', value: 'verticalNames', class: 'color', filterable: true },
            { text: 'Business Developer', value: 'advertiserManager', class: 'color', filterable: true},
            { text: 'Actions', value: 'actions', align: 'center', sortable: false}
          ],
          filters: {
            id: {active: false, selected: [], show: false, property: '', data: []},
            name: {active: false, selected: [], show: false, property: '', data: []},
            tags: {active: false, selected: [], show: false, property: '', data: []},
            email: {active: false, selected: [], show: false, property: '', data: []},
            status: {active: false, selected: [], show: false, property: '', data: []},
            advertiserManager: {active: false, selected: [], show: false, property: '', data: []},
            verticalNames: {active: false, selected: [], show: false, property: '', data: []},
          }
        },
      }
    },
    created() {
      if(this.$route.query.filters) {
        this.updateFiltersFromQuery();
      }
    },
    async mounted() {
      console.log('why do we wait for filters loading before table data loading?');
      await this.getFiltersData()
      await this.getTableData()
      verticalsApi.verticals().then(result => {
        this.verticals = [...result];
        console.log('THIS VERTICALS', this.verticals);
        this.table.filters['verticalNames'].data = [...this.verticals].map(v => ({key: v.name, value: v.name}));
      });
      advertisers.getTermsAndMethods().then(result => this.methods = [...result.methods]);
    },
    methods: {
      ...mapActions('alert', ['ALERT_SUCCESS', 'ALERT_ERROR', 'ALERT_INFO', 'ALERT_WARNING', 'ALERT']),
      addEmail() {
        const pattern = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
        if (!pattern.test(this.emailInput.trim())) {
          this.emailError = true;
          setTimeout(()=>{this.emailError = false}, 2000);
          return;
        }
        if (this.emailInput.trim() !== '') {
          this.emails.push(this.emailInput.replace(';','').trim());
          this.emailInput = '';
        }
      },
      removeEmail(index) {
        this.emails.splice(index, 1);
      },
      checkForSpecialSymbol(event) {
        const separators = [' ', ',', ';', 'Tab', 'Enter'];
        if (separators.includes(event.key)) {
          event.preventDefault();
          this.addEmail();
        }
      },
      async createAdvertiser() {
        if (this.saveAdvertiserValidation) {
          this.showErrors = true;
          setTimeout(() => {
            this.showErrors = false;
          }, 5000);
          return;
        }
        this.loading = true;

        const filesData = [];

        if (this.newAdvertiserData.files && this.newAdvertiserData.files.length) {
          for (let file of this.newAdvertiserData.files) {
            const fileData = await convertFileToBase64(file);
            filesData.push(fileData);
          }
        }

        advertisers.createAdvertiser({
          name: this.newAdvertiserData.name,
          status: this.newAdvertiserData.status,
          advertiserManager: this.newAdvertiserData.advertiserManagerId,
          website: this.newAdvertiserData.website,
          description: this.newAdvertiserData.description,
          productDescription: this.newAdvertiserData.productDescription,
          billingCycle: this.newAdvertiserData.billingCycle,
          businessName: this.newAdvertiserData.businessName,
          emails: this.emails.join(';'),
          margin: this.newAdvertiserData.margin || 0,
          verticals: this.selectedVerticalIds,
          imService: this.newAdvertiserData.IMService,
          imContact: this.newAdvertiserData.IMContact,
          methodId: this.newAdvertiserData.methodId || 0,
          paymentDetails: this.newAdvertiserData.paymentDetails,
          files: filesData
          }).then(res => {
              const errors = res.data.errors;
              if (errors && errors.length > 0) {
                this.ALERT_ERROR(`Server error: ${errors[0].message}`);
                this.loading = false;
                return;
              }

              const advertiser = res.data.data.addAdvertiser;

              this.profiles.data.unshift({
                id: advertiser.id,
                advertiserManager: advertiser.advertiserManager,
                name: advertiser.name,
                status: advertiser.status,
                email: advertiser.email,
                margin: advertiser.margin
              });

              this.ALERT_SUCCESS('Advertiser created');
              this.newAdvertiserData = { status: 'active' };
              this.loading = false;

              setTimeout(() => {
                this.ALERT_SUCCESS('');
              }, 6000);

              this.openModalNewAdvertiser = false;
            })
          .catch(err => {
            this.ALERT_ERROR('Create advertiser server error pls try again later');
            this.loading = false;
          });

        this.emails = [];
      },
      clearPaymentDetails() {
        this.newAdvertiserData.paymentDetails = {};
      },
      closeModalNewAdvertiser() {
        this.newAdvertiserData = {
          status: 'active'
        }
        this.showErrors = false;
        this.openModalNewAdvertiser = false;
      },
      isEntityName(item) {
        return ['name'].includes(item)
      },
      showCard(item) {
        store.dispatch('cards/ADD', {
          type: 'advertiser',
          title: item.name,
          key: `advertiser-${item.id}`,
          data: item
        })
      },
      async getFiltersData() {
        const filters = {};
        for(const name in this.table.filters) {
          if (name === 'verticalNames') continue;
          advertisers.getFilter({
            filter: filters,
            name: name,
          }).then(res => {
            this.table.filters[name].data = res;
          });
        }
      },
      async getTableData() {
        this.table.loading = true
        this.activateFilters()
        const filters = await this.getFilters();
        await store.dispatch('advertiser/getProfiles', {
          limit: this.table.itemsPerPage,
          page: this.table.currentPage,
          orderBy: this.table.orderBy,
          orderDirectionAsc: this.table.sortColumnsAsc,
          filters: filters || null
        })
        this.table.loading = false
      },
      addParamsToLocation(params) {
        const query = JSON.stringify(params) === '{}' ? this.$route.path :
            this.$route.path + '?' + Object.keys(params).map(
            key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`
            ).join('&')
        history.pushState({},null, query);
      },
      updateFiltersFromQuery() {
        const queryFilters = JSON.parse(this.$route.query.filters);
        for(const name in this.table.filters) {
          if(queryFilters[name]) {
            this.table.filters[name].selected = queryFilters[name];
          }
        }
      },
      async getFilters() {
        const filters = {};
        filters['search'] = (this.searchInProfiles.length > 0) ? this.searchInProfiles : '';
        for(const name in this.table.filters) {
          filters[name] = (this.table.filters[name].selected.length > 0) ?
              `'${this.table.filters[name].selected.join('\',\'')}'` :
              null;
        }

        return filters;
      },
      async submitFilter(data, entity) {
        this.table.currentPage = 1;
        this.table.pageChangedByMe = true;
        if(data && entity) {
          this.table.filters[entity].selected = data;
        }
        return await this.getTableData()
      },
      activateFilters() {
        const filtersForQuery = {};
        for (const name in this.table.filters) {
          if(this.table.filters[name].selected.length > 0) {
            filtersForQuery[name] = this.table.filters[name].selected;
          }
        }
        this.addParamsToLocation(
            JSON.stringify(filtersForQuery) !== '{}' ? {filters: JSON.stringify(filtersForQuery)} : {}
        );
      },
      async updateDataInFilters(data, modalName) {
        if(modalName) {
          advertisers.getFilter({
            filter: this.table.filters,
            name: modalName,
            searchFilter: data
          }).then(res => {
            this.table.filters[modalName].data = res;
          });
        }
      },
      async sortColumn(column) {
        this.table.sortColumnsAsc = (this.table.orderBy === column) ? !this.table.sortColumnsAsc : true;
        this.table.orderBy = column
        await this.getTableData()
      },
      getStoreData(name) {
        if(this.filtersData && this.filtersData[name]) {
          return this.filtersData[name];
        }
      },
      getReportsUrl(item) {
        const filters = '?filters=' + encodeURI(JSON.stringify({field: 'advertiser_id', value: [`${item.id}`]}))
        return '/analytics/reports/advertisers' + filters;
      },

      search(value) {
        this.searchInProfiles = value;
        this.submitFilter();
      },

      updateTablePagination(params){
        if (
            (this.table.currentPage === params.page &&
                this.table.itemsPerPage === params.itemsPerPage) ||
            this.table.pageChangedByMe
        ) {
          this.table.pageChangedByMe = false;
          return
        }
        this.table.currentPage = params.page
        this.table.itemsPerPage = params.itemsPerPage
        if(this.$route.query.filters) {
          this.updateFiltersFromQuery();
        }
        this.getTableData();
      },
      async removeAllFilters() {
        for (let key in this.table.filters) {
          this.table.filters[key].selected = [];
        }
        await this.getTableData()
      },
      editAdvertiser(item) {
        window.open(`/advertiser/${item.id}`, '_blank');
      },
      async activateEmailManually(item) {
        try {
          if (!item.verified) {
            this.loading = true;
            item.verified = new Date().toISOString().slice(0, 19).replace('T', ' ');
            // await store.dispatch('affiliates/saveAffiliateProfile', item)
            const updatedData = {
              id: item.id,
              status: item.status,
              name: item.name,
              managerId: item.advertiserManagerId,
              verified: item.verified
            };
            await store.dispatch('advertiser/updateSflAdvertiser', updatedData);
            store.dispatch('alert/ALERT_SUCCESS', `Advertiser email has been activated`, {root: true});
          } else {
            store.dispatch('alert/ALERT_INFO', `Advertiser email is already activated`, {root: true});
          }
          setTimeout(() => {
            store.dispatch('alert/ALERT_REMOVE', ``, {root: true});
          }, 6000);
        } catch (e) {
          store.dispatch('alert/ALERT_ERROR', `An error has occurred.`, {root: true});
          setTimeout(() => {
            store.dispatch('alert/ALERT_REMOVE', ``, {root: true});
          }, 6000);
        }
        this.loading = false;
      },
      async exportAdvertiserList() {
        this.activateFilters()
        const filters = await this.getFilters();
        await store.dispatch('advertiser/getAdvertiserProfileDataCOWithoutPagination', {
            limit: 999999,
            page: 1,
            orderBy: this.table.orderBy || '',
            orderDirectionAsc: this.table.sortColumnsAsc || false,
            filters: filters || null
        });

        this.isShowOpenSettingsModal = !this.isShowOpenSettingsModal;
      },
      addNewVertical() {
        if (this.searchTerm && !this.filteredVerticals.some(v => v.name === this.searchTerm)) {
          this.affiliateVerticalsAll.unshift({ name: this.searchTerm });
          this.newItems.push(this.searchTerm);
          this.selectedVerticals.push(this.searchTerm);
          this.searchTerm = '';
        } else if (this.searchTerm) {
          this.error = 'This vertical already exists';
        }
      },
      removeVertical(index) {
        this.selectedVerticals.splice(index, 1);
      },
    },
    watch: {
      selectedVerticals(newVal) {
        this.selectedVerticalIds = [...this.verticals.filter(ver=>newVal.includes(ver.name)).map(ver=>ver.id)];
      }
    },
    computed: {
      ...mapGetters('advertiser', ['profiles', 'filtersData']),
      ...mapState('user', ['user']),
      saveAdvertiserValidation() {
        return !(
            !!this.newAdvertiserData.name
            && !!this.newAdvertiserData.advertiserManagerId && !!this.newAdvertiserData.description && !!this.newAdvertiserData.businessName
            && (!!this.newAdvertiserData.website || !!this.newAdvertiserData.productDescription) && this.emails.length
            && (!!this.newAdvertiserData.margin || Number(this.newAdvertiserData.margin) === 0)
            && this.user[0].can('edit_payin_payout')
            && Number(this.newAdvertiserData.margin) >= 0
            && !!this.newAdvertiserData.billingCycle
        );
      },
      currentPaymentMethod() {
        if (!this.methods.length || !this.newAdvertiserData) {
          return null;
        }
        return this.methods.find(m => m.id === this.newAdvertiserData.methodId)
      },
      filteredVerticals() {
        if (!this.searchTerm) {
          return this.verticals;
        }

        return this.verticals.filter(vertical =>
           vertical.name.toLowerCase().includes(this.searchTerm.toLowerCase())
        );
      },
    },

    components: {
      MainLayout,
      DataTableTopBar,
      DataTableBottomBar,
      ExportSettingsModal,
    },

  }
</script>

<style lang="sass">
.chip
  display: inline-block
  color: white
  background-color: var(--v-primary-base)
  padding: 5px 10px
  border-radius: 5px
  margin-right: 5px
  margin-bottom: 2px
.delete
   cursor: pointer
   margin-left: 5px
.custom-error
  color: red
.advertiser-profiles
  .v-data-table__wrapper
    overflow-y: auto
    .table-cell-title
      //font-weight: 700
      color: #555555

.theme--light.v-data-table .v-data-table-header th.sortable.active,
.theme--light.v-data-table .v-data-table-header th.sortable.active .v-data-table-header__icon,
.theme--light.v-data-table .v-data-table-header th.sortable:hover
  color: rgb(127, 152, 165) !important
  caret-color: rgb(127, 152, 165) !important

.theme--light.v-data-table .v-data-table-header th.sortable .v-data-table-header__icon
  font-size: 16px !important
.v-data-table
  a.entity-link
    color: var(--v-primary-base)
.tipalti-logo
  height: 20px !important
  vertical-align: bottom !important

</style>
